module.exports = function (options) {
  var sub_options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var classname = options["class"] ? options["class"] : '';
  var html = "<li id=\"".concat(options.id, "\" class=\"game-menu-option ").concat(classname, "\"><div class=\"game-menu-option-label\"><span>").concat(options.text, "</span>");
  if (sub_options.length > 0) {
    html += '<i class="fa-solid fa-chevron-down game-menu-accordion-icon" aria-hidden="true"></i>';
  }
  html += '</div>';
  if (sub_options.length > 0) {
    html += '<ul class="game-menu-sub-options">';
    for (var z = 0; z < sub_options.length; z++) {
      classname = sub_options[z]["class"] ? sub_options[z]["class"] : '';
      html += "<li id=\"".concat(sub_options[z].id, "\" class=\"game-menu-sub-option ").concat(classname, "\"><div class=\"game-menu-option-label\"><span>").concat(sub_options[z].text, "</span>");
      if (sub_options[z].sub_menu) {
        html += '<i class="fa-solid fa-chevron-down game-menu-accordion-icon" aria-hidden="true"></i>';
      }
      html += '</div>';
      if (sub_options[z].sub_menu) {
        html += '<ul class="game-menu-sub-sub-options">';
        for (var y = 0; y < sub_options[z].sub_menu.length; y++) {
          html += "<li id=\"".concat(sub_options[z].sub_menu[y].id, "\" class=\"game-menu-sub-sub-option\"><div class=\"game-menu-option-label\">").concat(sub_options[z].sub_menu[y].text, "</div>");
        }
        html += '</ul>';
      }
      html += "</li>";
    }
    html += '</ul>';
  }
  html += '</li>';
  return html;
};